import { SIGNUP_NEW, SIGNUP_INVITED } from 'actions/Types';

export default function signedUp(state = false, action) {
  if (
    action.type === `${SIGNUP_NEW}_SUCCESS` ||
    action.type === `${SIGNUP_INVITED}_SUCCESS`
  ) {
    return true;
  }

  return state;
}
